import { CircleDollarSign, DollarSign, Mail, Phone, Save, X } from "lucide-react"
import { Button } from "../button"
import { Card, CardContent, CardHeader, CardTitle } from "../card"
import InfoIcon from "../../../static/media/icons/info-icon.svg?react"
import CalendarIcon from "../../../static/media/icons/calendar-icon.svg?react"
import { Avatar } from "../avatar"
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../dialog"

type CreditUsageProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const CreditUsage = ({ open, onOpenChange }: CreditUsageProps) => {
  const totalCredits = 1000
  const availableCredits = 900
  const percentage = Math.max(0, Math.min(100, Math.round((availableCredits / totalCredits) * 100)))
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[400px] rounded-xl border p-0">
        <DialogHeader className="flex flex-row items-start justify-between border-b border-border p-5">
          <DialogTitle className="flex flex-row items-center gap-3.5">
            <span className="flex items-center justify-center rounded-full border p-[10px]">
              <CircleDollarSign className="size-5 text-gray-600" />
            </span>
            <div className="flex flex-col items-start">
              <span className="text-sm font-medium text-gray-950">Credit Usage</span>
              <span className="text-xs font-normal text-gray-600">Check your credit balance and usage</span>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-5 p-5">
          <Card className="p-4">
            <CardHeader className="border-b p-0 pb-4">
              <CardTitle className="text-sm font-medium text-gray-950">Credit Balance</CardTitle>
            </CardHeader>
            <CardContent className="p-0 pt-4">
              <div className="mb-4 flex flex-col gap-1">
                <span className="text-[18px] font-normal text-gray-600">
                  You have <span className="text-[18px] font-medium text-gray-950">{availableCredits} credits</span>{" "}
                </span>

                <span className="flex items-center gap-1 text-xs font-normal text-gray-600">
                  <InfoIcon className="size-5" />
                  Renewal on Aug 16, 2025 12:30 PM
                </span>
              </div>

              {/* progressbar */}
              <div className="mt-3 flex items-center gap-3">
                <div
                  className="relative h-3 flex-1 rounded-full bg-gray-200"
                  role="progressbar"
                  aria-valuenow={percentage}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label="Available credits percentage"
                >
                  <div className="h-3 rounded-full bg-blue-600 transition-[width] duration-500 ease-out" style={{ width: `${percentage}%` }} />
                </div>
                <span className="text-xs font-medium text-gray-600">{percentage}%</span>
              </div>

              <div className="mt-4 flex flex-row items-center justify-between rounded-lg border px-[10px] py-1.5">
                <span className="text-xs font-normal text-gray-600">
                  Your plan includes
                  <span className="font-medium"> {totalCredits} credits</span>.
                </span>

                <button className="cursor-pointer text-xs font-medium text-[#335CFF]">Upgrade</button>
              </div>
            </CardContent>
          </Card>

          {/* breakdown */}
          <Card className="p-4">
            <CardHeader className="flex flex-row items-center justify-between border-b p-0 pb-4">
              <CardTitle className="text-sm font-medium text-gray-950">Spend Breakdown</CardTitle>
              <Button variant="outline" className="!my-0 h-6 space-y-0 px-[10px] py-1 text-xs font-normal text-gray-600">
                <CalendarIcon className="size-5" /> Feb 04 - Feb 11 2024
              </Button>
            </CardHeader>
            <CardContent className="p-0 pt-4">
              <div className="flex flex-row justify-between">
                <div className="flex flex-row items-start gap-2">
                  <Avatar className="flex items-center justify-center rounded-full border p-1">
                    <Mail className="size-4 text-[#335CFF]" />
                  </Avatar>
                  <div className="flex flex-col gap-1">
                    <span className="text-xs font-medium text-gray-400">EMail </span>
                    <span className="text-sm font-medium text-gray-950">100 Credits</span>
                    <div className="flex flex-row items-center justify-center rounded-full bg-[#C0D5FF] px-2 pt-0.5 text-xs font-medium text-[#122368]">
                      25 Reveals
                    </div>
                  </div>
                </div>

                <div className="border-l"></div>

                <div className="flex flex-row items-start gap-2">
                  <Avatar className="flex items-center justify-center rounded-full border p-1">
                    <Phone className="size-4 text-[#335CFF]" />
                  </Avatar>
                  <div className="flex flex-col gap-1">
                    <span className="text-xs font-medium text-gray-400">Phone Numbers</span>
                    <span className="text-sm font-medium text-gray-950">100 Credits</span>
                    <div className="flex flex-row items-center justify-center rounded-full bg-[#C0D5FF] px-2 pt-0.5 text-xs font-medium text-[#122368]">
                      100 Reveals
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <DialogFooter className="border-t p-5">
          <DialogClose asChild>
            <Button variant="outline" className="w-full rounded-lg p-2 text-sm font-medium text-[#5C5C5C]">
              Cancel
            </Button>
          </DialogClose>
          <Button
            variant="outline"
            // onClick={handleSave}
            // disabled={isSaveDisabled}
            className="w-full rounded-lg bg-[#335CFF] p-2 text-sm font-medium text-white hover:bg-[#335CFF] hover:text-white"
          >
            Export
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default CreditUsage
